<div class="fertilizer-container bk-modal__left bk-modal__left-fertilizers">
	<div class="bk-modal__left-fertilizer-options block">
		<mat-radio-group aria-label=""
			name="fertilizerAddChoice"
			[(ngModel)]="isCustomFertilizer">
			<span *ngFor="let state of addStates"
				class="bk-modal__label bk-modal__left-fertilizer-option">
				<mat-radio-button [value]="state.value"
					[disabled]="!state.value && areThereFertilizers"
					name="fertilizerAddChoice">
					{{state.display}}
				</mat-radio-button>
			</span>
		</mat-radio-group>
	</div>
</div>
<ng-container *ngIf="fertilizers && !isCustomFertilizer">
	<fertilizer-list [fertilizers]="selectableFertilizers"
		[showTypeTabs]="true"
		[fertilizerTabIndex]="fertilizerTabIndex"
		(fertilizerTabChange)="onFertilizerTabChange($event)">
	</fertilizer-list>
</ng-container>
<ng-container *ngIf="isCustomFertilizer">
	<div class="block bk-modal__right cm-fertilizer-dialog__custom-edit-frame">
		<fertilizer-edit [fertilizer]="fertilizer"
			[showMineralizationFields]="false"
			(form)="updateFormState($event)">
		</fertilizer-edit>
	</div>
</ng-container>
